export const _LOAD_MODEL_ = 'Load:Supervisor';
export const _DELETE_SUPERVISOR_ = 'Delete:Supervisor';

export const MODEL = {
  id: null,
  name: '',
  email: '',
  resellers_count: null,
};
